import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import { ACTION_BLUE } from '../../theme/theme';

interface NationalIdInfoModalProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Explains whose کارت ملی belongs on a legal identity: the مدیر عامل, or the
 * نماینده whose details were entered on the form. Mirrors ContractInfoModal.
 */
const NationalIdInfoModal: React.FC<NationalIdInfoModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="national-id-info-modal"
      aria-describedby="modal-with-national-id-information"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '340px', sm: '80%', md: '600px' },
          maxWidth: '600px',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          direction: 'rtl',
        }}
      >
        <Typography
          id="national-id-info-modal"
          variant="h6"
          component="h2"
          sx={{
            textAlign: 'right',
            color: '#25282E',
            fontSize: 18,
            fontFamily: 'IRANYekanXFaNum',
            fontWeight: 700,
            mb: 3,
            pb: 2,
            borderBottom: '1px solid #E5E5E8',
          }}
        >
          توضیحات تصویر کارت ملی
        </Typography>

        <Typography
          sx={{
            textAlign: 'right',
            color: '#60646E',
            fontSize: 14,
            fontFamily: 'IRANYekanXFaNum',
            lineHeight: '24px',
            mb: 3,
            p: 2,
            backgroundColor: '#F8F9FA',
            borderRadius: 1,
            border: '1px solid #E9ECEF',
          }}
        >
          تصویر کارت ملی مربوط به مدیر عامل مجموعه می‌باشد یا در صورتی که یک
          شخص به عنوان نماینده معرفی می‌گردد باید تصویر کارت ملی با اطلاعات
          وارد شده شخص نماینده مطابقت داشته باشد.
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            onClick={onClose}
            variant="contained"
            sx={{
              backgroundColor: ACTION_BLUE,
              color: '#FFFFFF',
              fontFamily: 'IRANYekanXFaNum',
              fontSize: 14,
              fontWeight: 500,
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#1565C0',
              },
            }}
          >
            بستن
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default NationalIdInfoModal;
